// @flow
import React, {
  useEffect,
  useState,
} from 'react';
import { Provider } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';

/**
 * Still an issue with the latest version available at the moment of writing (v6)
 * https://github.com/rt2zz/redux-persist/issues/953#issuecomment-449545453
 */
// $FlowFixMe
import { PersistGate } from 'redux-persist/integration/react';

import { ThemeProvider } from 'styled-components';
import { GlobalStyle as BaseWagGlobalStyle } from '@waglabs/webapp-theme';

import {
  store,
  persistor,
} from '../../store';
import {
  GlobalStyle,
  Theme,
} from '../Theme';

import { AppInstallBannerProvider } from '../AppInstallBanner';
import { TrackingProvider } from '../../services/Tracking';
import NavigationPage from '../NavigationPage';
import { SpinnerProvider } from '../Spinner';

import '../../polyfills';

type Props = {
  children: any,
  currentPathname: string,
  currentUrl: string,
  disableAppInstall?: boolean,
  disableNavbar?: boolean,
  disableFooter?: boolean,
};

export const Layout = ({
  children,
  currentPathname,
  currentUrl,
  disableAppInstall,
  disableFooter,
  disableNavbar,
}: Props) => {
  const [stripe, setStripe] = useState(null);

  // Creates Stripe instance while it loads asynchronously
  useEffect(() => {
    const { Stripe } = window;
    if (Stripe) {
      setStripe(Stripe(process.env.GATSBY_REACT_APP_STRIPE_PUBLIC_KEY));
    } else {
      const stripeJsDOM = document.getElementById('stripe-js');

      if (!stripeJsDOM) {
        return;
      }

      // Create Stripe instance once Stripe.js loads
      stripeJsDOM.addEventListener('load', () => {
        setStripe(window.Stripe(process.env.GATSBY_REACT_APP_STRIPE_PUBLIC_KEY));
      });
    }
  }, []);

  const renderChildren = () => {
    if (disableAppInstall) {
      return children;
    }

    return (
      <TrackingProvider>
        <AppInstallBannerProvider>
          <NavigationPage
            currentPathname={currentPathname}
            currentUrl={currentUrl}
            disableFooter={disableFooter}
            disableNavbar={disableNavbar}
          >
            {children}
          </NavigationPage>
        </AppInstallBannerProvider>
      </TrackingProvider>
    );
  };

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={Theme}>
          <SpinnerProvider>
            <StripeProvider stripe={stripe}>
              <>
                <BaseWagGlobalStyle />
                <GlobalStyle />
                {renderChildren()}
              </>
            </StripeProvider>
          </SpinnerProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

Layout.defaultProps = {
  disableAppInstall: false,
  disableFooter: false,
  disableNavbar: false,
};
